import { ebayPacklink_shop2shop } from "./ebayPacklink_shop2shop";
import { dpd_home } from "./_DPD";
import { ebayPacklink_mondialRelay } from "./ebayPacklink_mondialRelay";
import { sendcloud_packAndCarry_ups } from "./sendcloud_packAndCarry_UPS";
import { temu_fedex } from "./temu_fedex";
import { leboncoin_mondialRelay } from "./leboncoin_mondialRelay";
import { leboncoin_shop2shop } from "./leboncoin_shop2shop";


export default [
    // dpd_home,
    ebayPacklink_shop2shop,
    ebayPacklink_mondialRelay,
    sendcloud_packAndCarry_ups,
    temu_fedex,
    leboncoin_mondialRelay,
    leboncoin_shop2shop
]